import React from 'react'

const componentPromise = import('./generic' /* webpackChunkName: "generic"*/)

const Component = React.lazy(() => componentPromise)

export default Component
